import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aa22424"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "preview_box" }
const _hoisted_3 = { class: "preview_item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "行驶证正页", -1))
const _hoisted_5 = { class: "preview_item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "行驶证附页", -1))
const _hoisted_7 = { class: "preview_item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "最新年检记录", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1))
const _hoisted_10 = { class: "preview_box" }
const _hoisted_11 = { class: "preview_item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "前", -1))
const _hoisted_13 = { class: "preview_item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "后", -1))
const _hoisted_15 = { class: "preview_item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "左", -1))
const _hoisted_17 = { class: "preview_item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "右", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1))
const _hoisted_20 = { class: "preview_box" }
const _hoisted_21 = { class: "preview_item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "正页", -1))
const _hoisted_23 = { class: "preview_item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "附页", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("通过")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("不通过")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"200px"} }, null, -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px","font-weight":"700"} }, "请输入不通过的原因", -1))
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px","font-weight":"700"} }, "确定审核通过吗？", -1))
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.detail)
      ? (_openBlock(), _createBlock(_component_a_card, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions, {
              title: "行驶证认证信息",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "号牌号码" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.vehicle_travel_license_number), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "车辆类型" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.renderCarType(_ctx.detail?.vehicle_travel_type)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "所有人" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.vehicle_travel_owner), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "使用性质" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.carNatureText?.nature), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "车辆识别号" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.vin), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "注册日期" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.register_date ? _ctx.dateFormat(_ctx.detail?.register_date * 1000, false) : ''), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "发证日期" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.issue_date ? _ctx.dateFormat(_ctx.detail?.issue_date * 1000, false) : ''), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "签发机关" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.issuing_organizations), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "有效期" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.vehicle_travel_time ? _ctx.dateFormat(_ctx.detail?.vehicle_travel_time * 1000, false) : ''), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "能源类型" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.renderEnergy(_ctx.detail?.vehicle_energy_type)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "外廓尺寸(米)" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 长：" + _toDisplayString(_ctx.detail?.car_long) + "，宽：" + _toDisplayString(_ctx.detail?.car_width) + "，高：" + _toDisplayString(_ctx.detail?.car_height), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "总质量" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.standard_weight) + "kg", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "核定载质量" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.vehicle_tonnage) + "kg", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "挂车牌照号" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.trailer_vehicle_plate_number), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "车牌颜色" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.renderColor(_ctx.detail?.vehicle_color)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "提交时间",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.update_time), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "图片",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_image_preview_group, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.vehicle_travel_license_images?.front,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_4
                          ]),
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.vehicle_travel_license_images?.sub,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_6
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.vehicle_travel_license_images?.record,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_8
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_9,
            _createVNode(_component_a_descriptions, {
              title: "车辆信息",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "车辆类型" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.vehicle_type), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "吨(座)位" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.transportation_weight), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "车牌号" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.plate_number), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "使用性质",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.carNatureText?.nature), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "图片",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_image_preview_group, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.vehicle_images?.front,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_12
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.vehicle_images?.back,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_14
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.vehicle_images?.left,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_16
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.vehicle_images?.right,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_18
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_19,
            _createVNode(_component_a_descriptions, {
              title: "道路运输证信息",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "所有人" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.transportation_owner) + "kg", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "经营许可证号",
                  span: 2
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.road_transportation_permit_card), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "图片",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_image_preview_group, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.road_transportation_images?.front,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_22
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(_component_a_image, {
                              src: _ctx.detail?.road_transportation_images?.sub,
                              width: 150,
                              height: 150
                            }, null, 8, ["src"]),
                            _hoisted_24
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_25,
            _createVNode(_component_a_descriptions, {
              title: "审核信息",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "审核时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.audit ? _ctx.detail?.audit?.create_time : '未审核'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "审核结果",
                  span: 2
                }, {
                  default: _withCtx(() => [
                    (_ctx.detail?.status === 0)
                      ? (_openBlock(), _createBlock(_component_a_badge, {
                          key: 0,
                          status: "processing",
                          color: "red",
                          text: "审核中"
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.detail?.status === 1)
                      ? (_openBlock(), _createBlock(_component_a_badge, {
                          key: 1,
                          color: "green",
                          text: "通过"
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.detail?.status === 2)
                      ? (_openBlock(), _createBlock(_component_a_badge, {
                          key: 2,
                          color: "orange",
                          text: "未通过"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.detail?.audit?.reason)
                  ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                      key: 0,
                      label: "备注"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.detail?.audit?.reason), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.detail?.status === 0)
                  ? (_openBlock(), _createBlock(_component_a_descriptions_item, {
                      key: 1,
                      label: "审核操作",
                      span: 3
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setVisible(true, true))),
                          style: {"margin-right":"16px"},
                          type: "primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_26
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setVisible(true, false)))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_27
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _hoisted_28
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.pass ? '审核通过' : '审核不通过',
      onOk: _ctx.onAudit,
      confirmLoading: _ctx.loading
    }, {
      default: _withCtx(() => [
        (!_ctx.pass)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _hoisted_30,
              _createVNode(_component_a_textarea, {
                value: _ctx.reason,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reason) = $event)),
                placeholder: "请输入不通过的原因",
                rows: 4
              }, null, 8, ["value"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
      ]),
      _: 1
    }, 8, ["visible", "title", "onOk", "confirmLoading"])
  ]))
}